import { aiPodTenantMapping } from "../../../../services/aiPodTenantMapping";
import React, { useEffect, useState } from "react";
import { Button } from '../../../../components/ui/Button';
import { Checkbox } from '../../../../components/ui/Field';
import { Overlay } from '../../../../components/ui/Overlay';
import { Surface } from '../../../../components/ui/Surface';

interface Tenant {
  id: string;
  name: string;
}

interface AiPodTenantModalProps {
  isOpen: boolean;
  tenants: Tenant[];
  onClose: () => void;
  onSave: (selected: string[], aiPodId: string) => void;
  aiPodId: string;
}

const AiPodTenantModal: React.FC<AiPodTenantModalProps> = ({ isOpen, tenants, onClose, onSave, aiPodId }) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [tenantIds, setTenantIds] = useState<string[]>([]);

  const toggleTenant = (id: string) => {
    setTenantIds((prev) => (prev.includes(id) ? prev.filter((t) => t !== id) : [...prev, id]));
  };

  const getMapping = async () => {
    const data = await aiPodTenantMapping.listTenantMappingFromAiPod({ aiPodId });
    setTenantIds(data.map((item: any) => item.tenantId));
  };

  useEffect(() => {
    if (aiPodId) getMapping();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [aiPodId]);

  const handleSave = () => {
    const selected: string[] = tenantIds.map((t) => t);
    onSave(selected, aiPodId);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <Overlay className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-black/30" onClick={onClose}></div>

      <Surface tone="popover" className="relative w-full max-w-2xl mx-4 rounded-2xl border p-6 max-h-[85vh] overflow-y-auto">
        <h2 className="text-xl font-semibold text-agentic-text-primary">Tenant List</h2>
        <p className="text-sm text-agentic-text-secondary mt-1">Select tenants using the dropdown.</p>

        <div className="mt-5">
          <label className="block text-sm font-medium text-agentic-text-primary mb-1">Select Tenants</label>

          <div
            className="border border-gray-300 rounded-lg p-2 cursor-pointer select-none flex justify-between items-center"
            onClick={() => setDropdownOpen(!dropdownOpen)}
          >
            <span className="text-sm text-gray-700">
              {tenantIds.length > 0 ? `${tenantIds.length} selected` : "Choose tenants"}
            </span>
            <span className="text-gray-500">▼</span>
          </div>

          {dropdownOpen && (
            <div className="mt-1 border border-gray-300 rounded-lg bg-white shadow p-2 max-h-56 overflow-y-auto">
              {tenants.map((tenant) => (
                <label key={tenant.id} className="flex items-center gap-2 py-1 cursor-pointer">
                  <Checkbox
                   
                    checked={tenantIds.includes(tenant.id)}
                    onChange={() => toggleTenant(tenant.id)}
                  />
                  <span className="text-sm">{tenant.name}</span>
                </label>
              ))}
            </div>
          )}
        </div>

        <div className="flex items-center justify-end space-x-3 pt-4 mt-4">
          <Button tone="outline-muted"
            onClick={onClose}
            className="px-4 py-2 rounded-lg border"
          >
            Cancel
          </Button>

          <Button tone="primary-gradient"
            onClick={handleSave}
            className="px-4 py-2 rounded-lg"
          >
            Save
          </Button>
        </div>
      </Surface>
    </Overlay>
  );
};

export default AiPodTenantModal;
